import landing from "./Landing";

/**
 * Combine and export access control modules related to various features such as authentication, dashboard, and user request.
 * @constant {Object} AccessControl
 */
const LandingAccessControl = {
  ...landing,
};

export default LandingAccessControl;
